module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4gsIDQkbdkPoIQAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAAqklEQVRYw+3YSw6AIAwEUDDu9Uae3RvpCXBlYoyWX6cQne5Y8TJNoOBDCK7nGlznReDngWOLTffVb9f1tIS5OfCOap5gKQgOzIVJ7VUHpuJiKAhQwuWAIMA3XA0Mfg5q4GBALRwEqInjXUwggQQS+Aeg1mD6zwTR6VUBn3Dag0Ix0AqXPVFbtLQ4QdSboyrBWGJImAhMaaUFruhVZwXLBlrDzvL8AiaQQLkOVFpCYU2y+5cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/icons/Flight_path.png
// module id = 1075
// module chunks = 0